import logo from '../../assets/images/allGames/nux-logo.png';
import './loading.scss';
import { isPG } from '../../core/helpers/skinHelper';
import { Reconnect } from '../../containers/connectionWr/reconnect';

export function CurrencyChangeLoading({ t }) {
  if (isPG()) {
    return <Reconnect t={t} />;
  }

  return (
    <div className='loading-container'>
      <img src={logo} alt='Logo' className='logo' />
      <div className='lightning-line' />
    </div>
  );
}
